import { startAnalytics } from "@/lib/analytics";

// Démarrage de la mesure d'audience. Next charge ce fichier tout seul, au premier
// affichage, côté navigateur uniquement (c'est la convention `instrumentation-client`).
//
// ⚠️ Rien n'est envoyé hors atlanx.io. Sur la prod, PostHog est bien initialisé ici
// pour TOUT LE MONDE — c'est indispensable pour compter aussi ceux qui refusent —
// mais en mode `on_reject` : tant que le visiteur n'a pas répondu au bandeau, AUCUN
// stockage et AUCUNE capture. S'il accepte, le bandeau rappelle cette fonction ;
// s'il refuse, il reste compté anonymement, sans cookie.
startAnalytics();
